/**
 * Marks the header nav link for the current page with aria-current="page".
 *
 * Template parts are static HTML, so the active state is resolved here. The
 * longest matching path wins, so /my-account/orders/ beats /my-account/.
 */
function normalise(path) {
	return path.endsWith("/") ? path : `${path}/`;
}

export function initCurrentLinks() {
	const here = normalise(window.location.pathname);

	document.querySelectorAll("[data-amp-nav]").forEach((nav) => {
		let best = null;
		let bestLength = -1;

		nav.querySelectorAll("a[href]").forEach((link) => {
			const url = new URL(link.href, window.location.origin);
			if (url.origin !== window.location.origin) return;

			const path = normalise(url.pathname);
			const matches = path === "/" ? here === "/" : here.startsWith(path);
			if (matches && path.length > bestLength) {
				best = link;
				bestLength = path.length;
			}
		});

		if (best) best.setAttribute("aria-current", "page");
	});
}
